import Avatar from './Avatar';
import AvatarIcon from './AvatarIcon';

export default Avatar;
export { AvatarIcon };
